const url_prod = 'https://medico.innovador.interactiva.net.co/api/';
const url_local = 'http://127.0.0.1:8000/api/'

export const API_BASE_URL = url_prod;